export enum SopType {
	PARTICLES_SYSTEM_GPU = 'particlesSystemGpu',
	SHEAR = 'shear',
	TRANSFORM = 'transform',
	UV_LAYOUT = 'uvLayout',
	UV_TRANSFORM = 'uvTransform',
	UV_UNWRAP = 'uvUnwrap',
}
